<template>
  <section class="embed-frame product--embed">
    <span class="embed-frame-loading">
      <context-loading />

      {{ placeholder }}
    </span>

    <div
      id="credere-embed-app"
      class="embed-frame-content"
    />
  </section>
</template>

<script>
  /* eslint no-underscore-dangle: ['error', { allow: ['_INTERNAL'] }] */

  import { mapState } from 'vuex';

  import ContextLoading from '@cordel/components/Context/Loading.vue';

  export default {
    name: 'EmbedFrame',
    components: {
      ContextLoading,
    },
    props: {
      settings: {
        type: Object,
        default: () => ({}),
      },
      callbacks: {
        type: Object,
        default: () => ({}),
      },
      endpoint: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: 'Carregando...',
      },
    },
    computed: {
      ...mapState([
        'auth',
      ]),
    },
    watch: {
      settings(before, after) {
        let changed = true;

        try {
          if (true
            && before.simulations.read.uuid && after.simulations.read.uuid
            && typeof before.simulations.read.uuid !== typeof after.simulations.read.uuid
          ) {
            changed = false;
          }
        } catch (err) { /* */ }

        if (changed) {
          this.mount();
        }
      },
    },
    mounted() {
      this.mount();
    },
    methods: {
      mount() {
        this.initialize();
      },
      initialize() {
        const { CREDERE } = window;

        CREDERE._INTERNAL = CREDERE._INTERNAL || {};
        CREDERE._INTERNAL.endpoint = this.endpoint;

        CREDERE.element = '#credere-embed-app';
        CREDERE.settings = this.settings;
        CREDERE.callbacks = this.callbacks;

        CREDERE.src = `${process.env.VUE_APP_EMBED_URL}/${this.endpoint}`;

        CREDERE._INTERNAL.defer();

        if (CREDERE.reinitialize) {
          CREDERE.reinitialize();
        }
      },
    },
  };
</script>

<style lang="scss">
  .product--embed {
    #credere-embed-app {
      --padding: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .embed-frame {
    min-height: var(--cordel-spacing-xxblaster);
    padding: 0;
    position: relative;
  }

  .embed-frame-content {
    position: relative;
  }

  .embed-frame-loading {
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: row;
    gap: var(--cordel-spacing-xxxs);
    justify-content: center;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
  }
</style>
